import { getLeaseDealsValueRating } from 'site-modules/lease-deals/utils/get-lease-deals-value-rating';

export const calculateDealData = data => {
  if (!data) return null;

  const msrp = Number(data.msrp);
  const monthlyPayment = Number(data.monthlyPayment);
  const term = Number(data.term);
  const dueAtSigning = Number(data.dueAtSigning);

  const effectiveTerm = dueAtSigning === 0 ? term : term - 1;
  const lifetimeCost = monthlyPayment * effectiveTerm + dueAtSigning;
  const effectivePayment = lifetimeCost / term;
  const effectivePaymentRatio = (msrp * term) / (lifetimeCost * 12);

  if (!Number.isFinite(effectivePayment) || !Number.isFinite(effectivePaymentRatio)) {
    return null;
  }

  const { rating } = getLeaseDealsValueRating(effectivePaymentRatio);

  return {
    effectivePayment: effectivePayment.toFixed(2),
    effectivePaymentRatio,
    dueAtSigning,
    rating,
    msrp,
    monthlyPayment,
    term,
    lifetimeCost,
  };
};
